import React, { useEffect, useState } from 'react';
import { X, Plus } from 'lucide-react';
interface LinkedInFiltersProps {
  initialFilters?: string[];
  onAddFilter?: (filter: string) => void;
  onRemoveFilter?: (index: number) => void;
}
export const LinkedInFilters = ({
  initialFilters,
  onAddFilter,
  onRemoveFilter
}: LinkedInFiltersProps) => {
  const [filters, setFilters] = useState(initialFilters || ['Industry: Technology', 'Company size: 50-200', 'Location: United States']);
  const [newFilter, setNewFilter] = useState('');
  // Update filters when initialFilters changes
  useEffect(() => {
    if (initialFilters) {
      setFilters(initialFilters);
    }
  }, [initialFilters]);
  const addFilter = () => {
    if (newFilter.trim()) {
      const updatedFilters = [...filters, newFilter.trim()];
      setFilters(updatedFilters);
      if (onAddFilter) {
        onAddFilter(newFilter.trim());
      }
      setNewFilter('');
    }
  };
  const removeFilter = (indexToRemove: number) => {
    const updatedFilters = filters.filter((_, index) => index !== indexToRemove);
    setFilters(updatedFilters);
    if (onRemoveFilter) {
      onRemoveFilter(indexToRemove);
    }
  };
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      addFilter();
    }
  };
  return <div className="space-y-4" data-id="element-518">
      <div className="space-y-2" data-id="element-519">
        {filters.map((filter, index) => <div key={index} className="flex items-center justify-between px-3 py-2 bg-gray-50 border border-gray-200 rounded-md" data-id="element-520">
            <span className="text-sm text-gray-700" data-id="element-521">{filter}</span>
            <button onClick={() => removeFilter(index)} className="text-gray-400 hover:text-red-500 transition-colors" data-id="element-522">
              <X size={16} data-id="element-523" />
            </button>
          </div>)}
      </div>

      <div className="flex gap-2" data-id="element-524">
        <div className="relative flex-1" data-id="element-525">
          <input type="text" value={newFilter} onChange={e => setNewFilter(e.target.value)} onKeyDown={handleKeyDown} placeholder="Add new filter (e.g., Role: CTO)" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-purple-500 focus:border-transparent outline-none" data-id="element-526" />
        </div>
        <button onClick={addFilter} className="px-3 py-2 bg-gray-100 text-gray-700 rounded-md hover:bg-gray-200 flex items-center gap-1 transition-colors" disabled={!newFilter.trim()} data-id="element-527">
          <Plus size={16} data-id="element-528" />
          Add
        </button>
      </div>
    </div>;
};